'use client';

import { useEffect } from 'react';

export default function ScrollToTop() {
    useEffect(() => {
        // Set the initial position once. Repeated delayed resets can fight real
        // user input when media finishes loading after the page becomes usable.
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, []);

    return null;
}
